module.exports = __webpack_public_path__ + "img/upload-icon.30a8f8f6.svg";